/**
 * Menvora — oculta chrome sticky (CTA float + offer bar + banner) mientras
 * el formulario COD Releasit (#rsi_form_wrapper) está abierto.
 * Evita tapar «Datos de Entrega» (bug visto en Clarity).
 */
(function () {
  if (window.__menvoraCodChromeGuard) return;
  window.__menvoraCodChromeGuard = true;

  var CLASS = 'menvora-cod-form-open';
  var last = null;

  function formEl() {
    return document.getElementById('rsi_form_wrapper');
  }

  function isOpen() {
    var d = formEl();
    if (!d) return false;
    if (d.hasAttribute('open')) return true;
    if (typeof d.open === 'boolean' && d.open) return true;
    var form = d.querySelector('form._rsi_main_form_element') || d.querySelector('form');
    if (form && form.getAttribute('data-open') === 'true') return true;
    var cs = window.getComputedStyle(d);
    if (cs.display === 'none' || cs.visibility === 'hidden' || Number(cs.opacity) === 0) {
      return false;
    }
    var r = d.getBoundingClientRect();
    if (r.height < 120 || r.width < 120) return false;
    // Overlay típico Releasit: ocupa gran parte del viewport
    if ((cs.position === 'fixed' || cs.position === 'absolute') && r.height > window.innerHeight * 0.35) {
      return true;
    }
    return r.height > window.innerHeight * 0.55 && r.top < window.innerHeight * 0.25;
  }

  function apply(open) {
    if (last === open) return;
    last = open;
    document.body.classList.toggle(CLASS, open);
    try {
      window.dispatchEvent(new CustomEvent('menvora:cod-form-chrome', { detail: { open: open } }));
    } catch (e) {}
  }

  function sync() {
    apply(isOpen());
  }

  var mo = null;
  function watch(node) {
    if (!node || typeof MutationObserver !== 'function') return;
    if (mo) mo.disconnect();
    mo = new MutationObserver(sync);
    mo.observe(node, {
      attributes: true,
      attributeFilter: ['open', 'style', 'class', 'hidden'],
      childList: false,
      subtree: false,
    });
  }

  function boot() {
    sync();
    var d = formEl();
    if (d) watch(d);
    else if (typeof MutationObserver === 'function') {
      var bootMo = new MutationObserver(function () {
        var found = formEl();
        if (!found) return;
        bootMo.disconnect();
        watch(found);
        sync();
      });
      bootMo.observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  document.addEventListener(
    'toggle',
    function (ev) {
      if (ev.target && ev.target.id === 'rsi_form_wrapper') sync();
    },
    true
  );

  // Clicks en CTA Releasit: form puede abrir un frame después
  document.addEventListener(
    'click',
    function (ev) {
      var t = ev.target;
      if (!t || !t.closest) return;
      if (!t.closest('#rsi_buy_now_button, #floatingBuyNowButton, [data-rsi-cod-button="true"]')) return;
      window.setTimeout(sync, 50);
      window.setTimeout(sync, 250);
      window.setTimeout(sync, 800);
    },
    true
  );

  window.addEventListener('resize', sync);
  window.setInterval(sync, 1200);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
